import { observer } from "mobx-react";
import ScreenShotStore from "../../stores/ScreenShotStore";
import './index.css';
import { chatBubbleIcon, contentTypeImageIcon, downloadIcon, whiteCheckIcon } from "../../assets";
import CallStore from "../../stores/CallStore";
import strings from '../../localization/index'
import ShapeTool from "../ShapeTool";
import ScreenShotShapes from "../ScreenShotShapes";
import html2canvas from "html2canvas";
import UploadStore from "../../stores/UploadStore";
import SocketStore from "../../stores/SocketStore";
import MainStore from "../../stores/MainStore";
import { SelffixLoadingContext } from "../../contexts/SelffixLoadingContext";
import { useContext } from "react";
import { ModalAlertContext } from "../../contexts/ModalAlertContext";

const generateFilename = () => {
  const date = Date.now();
  const filename = `${CallStore.slug}-${date}`;
  return filename;
}

const ScreenShotView = () => {

  const { showSelffixLoading, closeSelffixLoading } = useContext(SelffixLoadingContext);
  const { showModalAlert, closeModalAlert } = useContext(ModalAlertContext);

  const sc = ScreenShotStore.sc;

  if (!sc) {
    return null;
  }

  const sliceLength = 20;

  const img = new Image();
  const filename = generateFilename();
  img.src = sc.toDataURL('image/png');


  const tools = [
    {
      key: 'circle',
      action: () => {
        ScreenShotStore.setSelectedShape('circle');
      },
    },
    {
      key: 'line-up',
      action: () => {
        ScreenShotStore.setSelectedShape('line-up');
      },
    },
    {
      key: 'rotate-left',
      action: () => {
        ScreenShotStore.setSelectedShape('rotate-left');
      },
    },
    {
      key: 'rotate-right',
      action: () => {
        ScreenShotStore.setSelectedShape('rotate-right');
      },
    },
    {
      key: 'color',
      action: () => {
        ScreenShotStore.setSelectedShape('color');
      },
    },
    {
      key: 'eraser',
      action: () => {
        ScreenShotStore.setSelectedShape('eraser');
      },
    }
  ];

  const uploadScreenshot = async () => {
    const element = document.getElementById('screen-shot-view-img-container');
    showSelffixLoading();

    try {
      return html2canvas(element).then(async (canvas) => {
        canvas.toBlob(async (blob) => {

          const file = new File([blob], filename, { type: blob.type });

          UploadStore.uploadFileToCall(file, CallStore.slug).then((response) => {
            if (response.success) {
              UploadStore.addSessionNotesFile({
                ...response.data,
                type: 'note'
              });
              ScreenShotStore.setShowScScreen(false);
              MainStore.setSessionInformationSelectedTab('session-notes');
              ScreenShotStore.clearStore();
            } else {
              showModalAlert({
                title: strings.error,
                message: response.message,
                onConfirm: () => {
                  closeModalAlert();
                },
                onCancel: null,
                type: 'error',
                confirmText: strings.ok,
              });
            }

            closeSelffixLoading();
          });

        });
      });
    } catch (error) {
      showModalAlert({
        title: strings.error,
        message: error.message,
        onConfirm: () => {
          closeModalAlert();
        },
        onCancel: null,
        type: 'error',
        confirmText: strings.ok,
      });
      console.error('İndirme başarısız:', error);
      closeSelffixLoading();
    }

  }

  const downloadImage = async () => {
    try {

      const element = document.getElementById('screen-shot-view-img-container');

      return html2canvas(element).then(async (canvas) => {
        canvas.toBlob(async (blob) => {
          const url = window.URL.createObjectURL(blob);

          const link = document.createElement('a');
          link.href = url;
          link.download = filename
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        });
      });


    } catch (error) {
      console.error('İndirme başarısız:', error);
    }
  };

  const sendScreenshot = async () => {
    const element = document.getElementById('screen-shot-view-img-container');

    showSelffixLoading();

    try {
      return html2canvas(element).then(async (canvas) => {
        canvas.toBlob(async (blob) => {
          // Create a new File object from the blob with the filename
          const file = new File([blob], filename, { type: blob.type });

          UploadStore.uploadFileToChat(file, CallStore.slug).then((response) => {
            if (response.success) {
              SocketStore.sendTechMessage({
                type: 'file',
                content: JSON.stringify(response.data)
              });
              ScreenShotStore.setShowScScreen(false);
              MainStore.setSessionInformationSelectedTab('chat');
              ScreenShotStore.clearStore();
            } else {
              showModalAlert({
                title: strings.error,
                message: response.message,
                onConfirm: () => {
                  closeModalAlert();
                },
                onCancel: null,
                type: 'error',
                confirmText: strings.ok,
              });
            }

            closeSelffixLoading();
          });

        });
      });
    } catch (error) {
      showModalAlert({
        title: strings.error,
        message: error.message,
        onConfirm: () => {
          closeModalAlert();
        },
        onCancel: null,
        type: 'error',
        confirmText: strings.ok,
      });
      closeSelffixLoading();
    }



  }

  const selectedShape = ScreenShotStore.selectedShape;

  return (
    <div className="screen-shot-view">

      <div className="screen-shot-view-container" >



        <div className="screen-shot-view-container-top" >
          <div className="edit-tools-container" >
            {tools.map((tool, index) => <ShapeTool tool={tool} index={index} selected={selectedShape === tool.key} isColorPickerOpen={selectedShape === 'color'} />)}
          </div>

          <div className="image-modal-content-inner">
            <div className="image-modal-buttons" >
              <div className="image-modal-content-inner-content-type">
                <img src={contentTypeImageIcon} alt="image" className="image-modal-content-inner-icon" />
                <span>{filename.length > sliceLength ? filename.slice(0, sliceLength) + '...' : filename}</span>
              </div>
              <button className="button-round button-round-medium" onClick={downloadImage}>
                <img src={downloadIcon} alt="download" />
              </button>
            </div>
            <div
              id="screen-shot-view-img-container"
              className="screen-shot-view-img-container"
            >
              <ScreenShotShapes />
              <img src={img.src} alt="image" />
            </div>
          </div>


        </div>

        <div className="screen-shot-view-container-bottom" >

          <button className="button-cta button-cta-medium" onClick={() => ScreenShotStore.setShowScScreen(false)}>
            <span>{strings.cancel}</span>
          </button>
          <button className="button-cta button-cta-medium" onClick={() => sendScreenshot()} style={{ width: 'fit-content' }} >
            <img src={chatBubbleIcon} alt="chat" />
            <span style={{ textTransform: 'uppercase' }} >{strings.sendToChat}</span>
          </button>

          <button className="button-cta-secondary button-cta-secondary-medium" onClick={() => uploadScreenshot()} style={{ width: 'fit-content' }} >
            <img src={whiteCheckIcon} alt="done" />
            <span style={{ textTransform: 'uppercase' }} >{strings.done}</span>
          </button>


        </div>
      </div >

    </div>
  );
}


export default observer(ScreenShotView);